import algoliasearch from 'algoliasearch'
import settings from '../../../config/settings'

const config = settings.algolia
const client = algoliasearch(config.appId, config.searchKey)

// initialises an index prefixed with the correct project id
const initIndex = name => client.initIndex(`${settings.firebase.config.projectId}_${name}`)

export default initIndex



// WEBPACK FOOTER //
// ./src/dataservices/utilities/algoliaInitIndex.js